import { PROBLEM_LIST, getProblemByKey } from "../journeyProblems";

export const CORE_JOURNEY_FAMILIES = {
  rel_breakup_fresh_pain: {
    labels: {
      he: "כאב פרידה טרייה",
      en: "Fresh breakup pain",
      es: "Dolor de ruptura reciente",
    },
    recognition: {
      he: [
        "משהו בי עדיין מחזיק במה שהיה.",
        "הראש מנסה להבין איך זה נגמר...",
        "אבל הלב עוד לא שחרר.",
      ],
      en: [
        "Something in me is still holding on to what was.",
        "My head keeps trying to understand how it ended...",
        "But my heart still has not let go.",
      ],
      es: [
        "Algo en mi todavia se aferra a lo que fue.",
        "Mi cabeza sigue intentando entender como termino...",
        "Pero mi corazon todavia no suelta.",
      ],
    },
  },
  rel_abandonment_fear: {
    labels: {
      he: "פחד נטישה",
      en: "Fear of abandonment",
      es: "Miedo al abandono",
    },
    recognition: {
      he: [
        "יש בי פחד לאבד קשר.",
        "גם לפני שמשהו באמת קורה...",
        "משהו בי כבר נלחץ.",
      ],
      en: [
        "There is a fear in me of losing connection.",
        "Even before something truly happens...",
        "Something in me is already tightening.",
      ],
      es: [
        "Hay en mi un miedo a perder el vinculo.",
        "Incluso antes de que algo pase de verdad...",
        "Algo en mi ya se tensa.",
      ],
    },
  },
  rel_rejection: {
    labels: {
      he: "כאב דחייה",
      en: "Rejection pain",
      es: "Dolor de rechazo",
    },
    recognition: {
      he: [
        "משהו בי נפגע כשאני לא נבחר.",
        "אני מנסה להמשיך הלאה...",
        "אבל בפנים זה עדיין נוגע בי.",
      ],
      en: [
        "Something in me gets hurt when I am not chosen.",
        "I try to move on...",
        "But inside it still touches me.",
      ],
      es: [
        "Algo en mi se hiere cuando no me eligen.",
        "Intento seguir adelante...",
        "Pero por dentro todavia me toca.",
      ],
    },
  },
  rel_betrayal_trust: {
    labels: {
      he: "קריסת אמון",
      en: "Trust collapse",
      es: "Colapso de confianza",
    },
    recognition: {
      he: [
        "משהו בי נסגר אחרי מה שקרה.",
        "קשה לי להרגיש בטוח ליד מישהו...",
        "ואני עדיין בודק אם אפשר לבטוח.",
      ],
      en: [
        "Something in me closed after what happened.",
        "It is hard for me to feel safe with someone...",
        "And I still keep checking whether trust is possible.",
      ],
      es: [
        "Algo en mi se cerro despues de lo que paso.",
        "Me cuesta sentirme seguro con alguien...",
        "Y sigo comprobando si se puede confiar.",
      ],
    },
  },
  self_worth: {
    labels: {
      he: "ערך עצמי",
      en: "Self-worth",
      es: "Valor propio",
    },
    recognition: {
      he: [
        "יש בי קול שלא מפסיק למדוד אותי.",
        "גם כשאני מנסה להמשיך...",
        "משהו בי עדיין לא מרגיש מספיק.",
      ],
      en: [
        "There is a voice in me that keeps measuring me.",
        "Even when I try to keep going...",
        "Something in me still does not feel like enough.",
      ],
      es: [
        "Hay una voz en mi que no deja de medirlo todo.",
        "Incluso cuando intento seguir...",
        "Algo en mi todavia no se siente suficiente.",
      ],
    },
  },
  self_shame: {
    labels: {
      he: "בושה פנימית",
      en: "Inner shame",
      es: "Verguenza interna",
    },
    recognition: {
      he: [
        "יש בי חלק שאני מסתיר.",
        "אני לא תמיד יודע איך להחזיק אותו...",
        "אבל הוא עדיין חי בתוכי.",
      ],
      en: [
        "There is a part of me that I hide.",
        "I do not always know how to hold it...",
        "But it is still alive inside me.",
      ],
      es: [
        "Hay una parte de mi que escondo.",
        "No siempre se como sostenerla...",
        "Pero sigue viva dentro de mi.",
      ],
    },
  },
  identity_confusion: {
    labels: {
      he: "בלבול זהות",
      en: "Identity confusion",
      es: "Confusion de identidad",
    },
    recognition: {
      he: [
        "אני לא לגמרי יודע איפה אני בתוך כל זה.",
        "משהו בי השתנה...",
        "ואני עדיין מנסה להבין מי אני עכשיו.",
      ],
      en: [
        "I do not fully know where I am inside all of this.",
        "Something in me has changed...",
        "And I am still trying to understand who I am now.",
      ],
      es: [
        "No termino de saber donde estoy dentro de todo esto.",
        "Algo en mi cambio...",
        "Y sigo intentando entender quien soy ahora.",
      ],
    },
  },
  anxiety_overthinking: {
    labels: {
      he: "חרדה וחשיבת יתר",
      en: "Anxiety and overthinking",
      es: "Ansiedad y sobrepensamiento",
    },
    recognition: {
      he: [
        "המחשבות שלי לא נחות.",
        "אני בודק שוב ושוב מה יכול לקרות...",
        "וקשה לי למצוא שקט.",
      ],
      en: [
        "My thoughts do not rest.",
        "I keep checking again and again what might happen...",
        "And it is hard for me to find quiet.",
      ],
      es: [
        "Mis pensamientos no descansan.",
        "Sigo revisando una y otra vez lo que podria pasar...",
        "Y me cuesta encontrar calma.",
      ],
    },
  },
  loneliness: {
    labels: {
      he: "בדידות",
      en: "Loneliness",
      es: "Soledad",
    },
    recognition: {
      he: [
        "יש בי מקום שמרגיש לבד.",
        "גם כשיש אנשים סביבי...",
        "משהו בי עדיין נשאר בלי חיבור.",
      ],
      en: [
        "There is a place in me that feels alone.",
        "Even when there are people around me...",
        "Something in me still stays without connection.",
      ],
      es: [
        "Hay un lugar en mi que se siente solo.",
        "Incluso cuando hay gente a mi alrededor...",
        "Algo en mi sigue sin conexion.",
      ],
    },
  },
  emotional_numbness: {
    labels: {
      he: "ריקנות וניתוק",
      en: "Emptiness and numbness",
      es: "Vacio y desconexion",
    },
    recognition: {
      he: [
        "יש בי חלק שנסגר.",
        "אני מרגיש רחוק ממה שאני באמת מרגיש...",
        "וכמעט אין לי מילים לזה.",
      ],
      en: [
        "There is a part of me that has closed.",
        "I feel far from what I truly feel...",
        "And I almost do not have words for it.",
      ],
      es: [
        "Hay una parte de mi que se cerro.",
        "Me siento lejos de lo que de verdad siento...",
        "Y casi no tengo palabras para eso.",
      ],
    },
  },
  grief_loss: {
    labels: {
      he: "אובדן ואבל",
      en: "Loss and grief",
      es: "Perdida y duelo",
    },
    recognition: {
      he: [
        "יש בי משהו שעוד מתאבל.",
        "החיים ממשיכים בחוץ...",
        "אבל בפנים עוד נשאר חסר.",
      ],
      en: [
        "There is something in me that is still grieving.",
        "Life keeps moving outside...",
        "But inside something is still missing.",
      ],
      es: [
        "Hay algo en mi que todavia esta de duelo.",
        "La vida sigue afuera...",
        "Pero por dentro todavia falta algo.",
      ],
    },
  },
  life_direction: {
    labels: {
      he: "כיוון ומשמעות",
      en: "Direction and meaning",
      es: "Direccion y sentido",
    },
    recognition: {
      he: [
        "אני מנסה להבין לאן החיים שלי הולכים.",
        "משהו שפעם היה ברור כבר לא ברור...",
        "ואני עדיין מחפש כיוון.",
      ],
      en: [
        "I am trying to understand where my life is going.",
        "Something that once felt clear no longer feels clear...",
        "And I am still looking for direction.",
      ],
      es: [
        "Intento entender hacia donde va mi vida.",
        "Algo que antes era claro ya no lo es...",
        "Y sigo buscando direccion.",
      ],
    },
  },
  fear_future: {
    labels: {
      he: "פחד מהעתיד",
      en: "Fear of the future",
      es: "Miedo al futuro",
    },
    recognition: {
      he: [
        "יש בי פחד ממה שעוד יכול לקרות.",
        "אני מנסה להתכונן לכל תרחיש...",
        "אבל בפנים קשה לי לנוח.",
      ],
      en: [
        "There is a fear in me of what could still happen.",
        "I keep trying to prepare for every scenario...",
        "But inside it is hard for me to rest.",
      ],
      es: [
        "Hay en mi un miedo a lo que todavia podria pasar.",
        "Intento prepararme para cada escenario...",
        "Pero por dentro me cuesta descansar.",
      ],
    },
  },
  control_loss: {
    labels: {
      he: "אובדן שליטה",
      en: "Loss of control",
      es: "Perdida de control",
    },
    recognition: {
      he: [
        "משהו בי מרגיש שאין לי על מה להישען.",
        "הכול זז מהר מדי...",
        "ואני רק מנסה למצוא קצת יציבות.",
      ],
      en: [
        "Something in me feels like there is nothing steady to lean on.",
        "Everything is moving too fast...",
        "And I am only trying to find a little stability.",
      ],
      es: [
        "Algo en mi siente que no tengo de donde sostenerme.",
        "Todo se mueve demasiado rapido...",
        "Y solo intento encontrar un poco de estabilidad.",
      ],
    },
  },
  self_forgiveness: {
    labels: {
      he: "סליחה לעצמי",
      en: "Self-forgiveness",
      es: "Perdonarme a mi mismo",
    },
    recognition: {
      he: [
        "יש בי משהו שאני עדיין מחזיק נגד עצמי.",
        "גם כשאני מבין מה קרה...",
        "משהו בי עוד לא סלח.",
      ],
      en: [
        "There is something in me I still hold against myself.",
        "Even when I understand what happened...",
        "Something in me still has not forgiven.",
      ],
      es: [
        "Hay algo en mi que todavia sostengo contra mi.",
        "Incluso cuando entiendo lo que paso...",
        "Algo en mi todavia no perdona.",
      ],
    },
  },
  emotional_healing: {
    labels: {
      he: "ריפוי רגשי",
      en: "Emotional healing",
      es: "Sanacion emocional",
    },
    recognition: {
      he: [
        "יש בי כאב ישן שעדיין חי.",
        "אני לא תמיד יודע איך להחזיק אותו...",
        "אבל משהו בי מבקש ריפוי.",
      ],
      en: [
        "There is an old pain in me that is still alive.",
        "I do not always know how to hold it...",
        "But something in me is asking for healing.",
      ],
      es: [
        "Hay un dolor viejo en mi que sigue vivo.",
        "No siempre se como sostenerlo...",
        "Pero algo en mi pide sanacion.",
      ],
    },
  },
};

const GROUP_FAMILY_FALLBACKS = {
  love_and_relationships: "rel_breakup_fresh_pain",
  self_worth: "self_worth",
  anxiety: "anxiety_overthinking",
  depression_emptiness_meaning: "emotional_numbness",
  loneliness_belonging: "loneliness",
  childhood_parents_past_wounds: "rel_abandonment_fear",
  parenting_children: "control_loss",
  work_money_career: "control_loss",
  loss_grief_radical_changes: "grief_loss",
  trauma_vulnerability: "emotional_healing",
  health_body_self_image: "emotional_healing",
  harmful_habits_light_addictions: "emotional_numbness",
  spirituality_faith_meaning: "life_direction",
  inner_identity_self_confusion: "identity_confusion",
};

const EXPLICIT_PROBLEM_FAMILIES = {
  rel_breakup_fresh_pain: "rel_breakup_fresh_pain",
  rel_breakup_fresh_pain_phase1: "rel_breakup_fresh_pain",
  rel_breakup_fresh_pain_reference_18d: "rel_breakup_fresh_pain",
  obsessive_longing: "rel_breakup_fresh_pain",
  jealousy_ex_moves_on: "rel_breakup_fresh_pain",
  lack_of_closure_after_breakup: "rel_breakup_fresh_pain",
  fear_never_find_love_again: "rel_abandonment_fear",
  getting_stuck_on_an_impossible_one_sided_love: "rel_breakup_fresh_pain",
  repeating_conflicts_in_relationship: "rel_abandonment_fear",
  fear_leaving_bad_relationship: "rel_abandonment_fear",
  lack_of_trust_in_relationship: "rel_betrayal_trust",
  pursuer_distancer_cycle: "rel_abandonment_fear",
  difficulty_expressing_needs_and_boundaries_with_partner: "rel_abandonment_fear",
  conditional_relationship_fear_of_abandonment: "rel_abandonment_fear",
  romantic_loneliness: "loneliness",
  fear_starting_relationship_dating_anxiety: "rel_abandonment_fear",
  repeated_attraction_to_destructive_partners: "rel_abandonment_fear",
  difficulty_opening_up_on_dates: "rel_rejection",
  i_am_not_enough: "self_worth",
  constant_comparison_to_others: "self_worth",
  chronic_sense_of_failure: "self_worth",
  difficulty_receiving_compliments_achievements: "self_worth",
  dependence_on_external_approval: "self_worth",
  cruel_self_judgment: "self_shame",
  harsh_self_criticism: "self_worth",
  need_to_be_perfect_in_everything: "self_worth",
  fear_of_mistakes: "self_worth",
  perfectionism_fear_of_mistakes_procrastination: "self_worth",
  low_self_esteem: "self_worth",
  chronic_feeling_of_failure: "self_worth",
  anxiety_vigilance: "anxiety_overthinking",
  anxiety_general: "anxiety_overthinking",
  catastrophic_thoughts: "fear_future",
  fear_meeting_people_social_events: "rel_rejection",
  shame_speaking_audience_work_meetings: "self_shame",
  feeling_strange_not_belong: "loneliness",
  replay_after_meeting: "anxiety_overthinking",
  anxiety_panic_attacks: "anxiety_overthinking",
  fear_leaving_safe_places: "fear_future",
  fear_of_rejection: "rel_rejection",
  fear_of_failure: "self_worth",
  fear_of_success: "self_worth",
  fear_of_being_alone_in_old_age: "fear_future",
  fear_of_illness_death: "fear_future",
  anxiety_fear_of_flying: "fear_future",
  anxiety_claustrophobia: "fear_future",
  overthinking_chronic_worry: "anxiety_overthinking",
  feeling_of_inner_emptiness_i_have_no_energy_for_anything: "emotional_numbness",
  lack_of_desire_lack_of_motivation: "emotional_numbness",
  difficulty_getting_up_in_the_morning_feeling_that_there_is_a_reason: "emotional_numbness",
  the_feeling_of_life_passed_me_by: "life_direction",
  loss_of_sense_of_identity_who_am_i_even_today: "identity_confusion",
  everything_is_fine_on_paper_but_inside_is_empty: "emotional_numbness",
  loneliness_even_when_there_are_people_around: "loneliness",
  i_have_no_one_who_really_knows_me: "loneliness",
  feeling_disconnected_from_the_family_children: "loneliness",
  difficulty_forming_deep_friendships: "loneliness",
  feeling_foreign_in_a_new_country_culture: "loneliness",
  i_m_always_the_one_who_listens_to_everyone_but_who_listens_to_me: "loneliness",
  feeling_of_abandonment_parents_are_emotionally_physically_unavailable: "rel_abandonment_fear",
  conditional_love_good_only_if_i_succeed: "self_worth",
  lack_of_protection_childhood_were_not_there_for_me: "rel_abandonment_fear",
  harsh_criticism_of_a_parent_that_lives_inside_me_to_this_day: "self_shame",
  an_inner_child_who_didn_t_feel_wanted_loved: "rel_abandonment_fear",
  a_critical_domineering_parent_even_in_adulthood: "self_shame",
  the_feeling_of_i_m_still_their_child_they_don_t_see_the_adult_in_me: "identity_confusion",
  difficulty_forgiving_a_parent_for_the_past: "self_forgiveness",
  a_sick_aging_parent_emotional_burden: "grief_loss",
  feelings_of_guilt_as_a_parent_i_ruined_their_lives: "self_forgiveness",
  conflicts_with_teenagers: "control_loss",
  difficulty_setting_boundaries_with_the_children: "control_loss",
  single_parent_parenting_after_divorce: "control_loss",
  children_who_live_in_another_country_far_away: "grief_loss",
  fear_the_children_will_stay_away_from_me_hate_me: "rel_abandonment_fear",
  burnout: "control_loss",
  task_load_home_work_imbalance: "control_loss",
  fear_of_losing_a_job_livelihood: "fear_future",
  conflicts_with_boss_colleagues: "rel_rejection",
  a_feeling_that_i_am_not_realizing_my_abilities: "self_worth",
  financial_anxiety_debts: "fear_future",
  fear_of_making_financial_decisions: "control_loss",
  stress_around_investments_risks: "fear_future",
  a_sense_of_financial_failure_compared_to_others: "self_worth",
  loss_of_a_loved_one_death: "grief_loss",
  but_about_the_end_of_a_relationship_a_family_that_fell_apart: "grief_loss",
  mourning_for_lost_health_chronic_illness_injury: "grief_loss",
  crossing_the_country_immigration_emotional_refugees: "grief_loss",
  retirement_retirement: "life_direction",
  empty_nest_the_children_have_left_the_house: "grief_loss",
  trauma_from_wars_disasters_accidents: "emotional_healing",
  trauma_after_betrayal_extreme_abandonment: "emotional_healing",
  repeated_emotional_injuries_humiliation_humiliation_shame: "self_shame",
  deep_distrust_in_humans_after_a_difficult_experience: "rel_betrayal_trust",
  flashbacks_bad_dreams_chronic_stress: "emotional_healing",
  living_with_chronic_pain: "emotional_healing",
  long_term_illness_my_own_a_family_member_s: "grief_loss",
  health_anxiety_every_symptom_a_movie_in_the_head: "fear_future",
  body_shame_weight_appearance: "self_shame",
  aging_getting_the_wrinkles_the_body_the_abilities: "grief_loss",
  emotional_eating: "emotional_numbness",
  escape_to_screens_phone_social_networks: "emotional_numbness",
  work_as_emotional_compensation_workaholism: "emotional_numbness",
  escaping_to_the_stochs_unattached_sex: "emotional_numbness",
  compulsive_buying_wasting_to_not_feel: "emotional_numbness",
  crisis_of_faith_anger_at_god_at_fate: "life_direction",
  religious_guilt_not_good_enough_in_the_eyes_of_heaven: "self_forgiveness",
  i_ve_lost_my_spiritual_connection_feeling: "life_direction",
  search_for_meaning_why_am_i_even_here: "life_direction",
  conflict_between_personal_values_and_religious_family_framework: "identity_confusion",
  i_don_t_know_who_i_am_anymore: "identity_confusion",
  collapse_of_old_roles_parent_spouse_successful: "identity_confusion",
  a_conflict_between_who_i_really_am_and_what_society_expects: "identity_confusion",
  confusion_about_the_choices_in_life_relationship_career_place_of_residence: "life_direction",
  difficulty_accepting_certain_parts_of_myself_sensitivity_weakness_inner_darkness: "self_shame",
};

export function getCanonicalJourneyFamily(problemKey = "") {
  const problem = getProblemByKey(problemKey);
  if (!problem) return "emotional_healing";
  return (
    EXPLICIT_PROBLEM_FAMILIES[problem.key] ||
    GROUP_FAMILY_FALLBACKS[problem.groupKey] ||
    "emotional_healing"
  );
}

export function getRecognitionLinesForProblem(problemKey = "", lang = "he") {
  const family = getCanonicalJourneyFamily(problemKey);
  const lines = CORE_JOURNEY_FAMILIES[family]?.recognition?.[lang];
  if (Array.isArray(lines) && lines.length) return lines;
  return CORE_JOURNEY_FAMILIES[family]?.recognition?.he || CORE_JOURNEY_FAMILIES.emotional_healing.recognition.he;
}

export function getProblemJourneyMappingRows() {
  return PROBLEM_LIST.filter((problem) => !problem.hidden).map((problem) => ({
    problemKey: problem.key,
    journeyBlueprintId: problem.journeyBlueprintId || problem.defaultJourneyBlueprintId || problem.key,
    familyId: getCanonicalJourneyFamily(problem.key),
  }));
}

export function getUnmappedProblemKeys() {
  return PROBLEM_LIST.filter((problem) => !problem.hidden)
    .map((problem) => problem.key)
    .filter((problemKey) => !EXPLICIT_PROBLEM_FAMILIES[problemKey] && !GROUP_FAMILY_FALLBACKS[getProblemByKey(problemKey)?.groupKey]);
}
